<template>
  <modal
    class="denyReason"
    name="denyReason"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @opened="opened"
    @closed="closed"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <!-- <span>
            <img src="@/assets/img/bank-building (2).svg" width="50px" />
          </span> -->
          {{ $t("text.priceManager.reasonFor") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="mt-4">
              <!-- <div style="display: flex; justify-content: flex-start">
                <label class="required">
                  {{ $t("text.priceManager.position") }}
                </label>
              </div> -->
              <!-- <div class="input__block" ref="target_input_div"> -->
              <textarea
                v-model="reason"
                class="w-100"
                name="reason"
                id=""
                rows="10"
                style="font-size: larger"
              ></textarea>
              <!-- <input
                  style="padding: 20px; width: 100%"
                  type=""
                  :placeholder="$t('text.priceManager.position')"
                  v-model="reason"
                /> -->
              <!-- </div> -->
            </div>

            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="denyApproval($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                <span>{{ $t("text.priceManager.decline") }} </span>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";

let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "denyReason",
  props: ["id", "status"],
  components: {},
  data() {
    return {
      reason: "",
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  watch: {},
  methods: {
    opened() {},

    closed() {
      this.reason = "";
    },

    denyApproval($event) {
      $event.preventDefault();

      if (this.reason == "") {
        this.$toast.open({
          message: this.$t("text.priceManager.missingPosition"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }

      const data = {
        status: this.status,
        reason: this.reason,
      };

      $(".loader").show();
      this.isButtonDisabled = true;

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Approval/UpdateStatus/${this.id}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;

          this.closeModal();
          this.closed();

          this.$toast.open({
            message: this.$t("text.priceManager.declineSuccess"),
            type: "success",
            duration: 4000,
          });

          this.reason = "";

          this.$eventHub.$emit("getPriceChange");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 4000,
          });
        });
    },

    closeModal() {
      this.$modal.hide("denyReason");
    },
  },
};
</script>
